package com.milta.core.localization.translations.pl

import com.milta.core.localization.LoadingAddressStrings

internal val LoadingAddress = LoadingAddressStrings(
    title = "Adres załadunku",
    emptyMessage = "Aby zoptymalizować trasę, wskaż, gdzie Twoi kierowcy ładują towar. Adres zostanie zapisany na kolejne trasy.",
    selectPlaceholder = "Wybierz adres załadunku",
    sheetSubtitle = "Miejsce, w którym Twoi kierowcy odbierają towar.",
    startPointBadge = "Punkt startowy",
    newAddressAction = "Nowy adres",
    mobileSearchPlaceholder = "Ulica, numer, miejscowość",
    webSearchPlaceholder = "Wyszukaj adres…",
    deleteDialogTitle = "Usunąć ten adres?",
    deleteDialogMessage = "„%s” nie będzie już proponowany. Utworzone już trasy się nie zmienią.",
    webSubmitBlockedHint = "Wybierz adres załadunku, aby zoptymalizować.",
    errorRequired = "Wybierz adres załadunku.",
)
